import { useEffect, useState } from 'react';
import Layout from '../components/layout';
import Title from '../components/title';
import { supabase } from '../supabase';
import './tablePage.css';
import searchIcon from '../assets/search.svg';
import editIcon from '../assets/edit.svg';
import deleteIcon from '../assets/delete.svg';

const FEEDBACK_PER_PAGE = 4;

const Feedback = () => {
  const [feedback, setFeedback] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [rating, setRating] = useState('5');
  const [message, setMessage] = useState('');
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [id, setId] = useState('');
  const [editFullName, setEditFullName] = useState('');
  const [editEmail, setEditEmail] = useState('');
  const [editRating, setEditRating] = useState('5');
  const [editMessage, setEditMessage] = useState('');
  const [isEditOpen, setIsEditOpen] = useState(false);

  const getFeedback = async () => {
    const res = await supabase.from('feedback').select('*').order('id', { ascending: false });
    setFeedback(res.data || []);
  };

  useEffect(() => {
    getFeedback();
  }, []);

  const createFeedback = async (e) => {
    e.preventDefault();
    await supabase.from('feedback').insert([{ full_name: fullName, email, rating: Number(rating), message }]);
    setFullName('');
    setEmail('');
    setRating('5');
    setMessage('');
    setIsCreateOpen(false);
    await getFeedback();
  };

  const editFeedback = (item) => {
    setId(item.id);
    setEditFullName(item.full_name || '');
    setEditEmail(item.email || '');
    setEditRating(item.rating || '5');
    setEditMessage(item.message || '');
    setIsEditOpen(true);
  };

  const updateFeedback = async (e) => {
    e.preventDefault();
    await supabase
      .from('feedback')
      .update({ full_name: editFullName, email: editEmail, rating: Number(editRating), message: editMessage })
      .eq('id', id);
    setIsEditOpen(false);
    await getFeedback();
  };

  const deleteFeedback = async (feedbackId) => {
    await supabase.from('feedback').delete().eq('id', feedbackId);
    await getFeedback();
  };

  const filteredFeedback = feedback.filter((item) => {
    const value = search.toLowerCase();
    return item.id.toString().includes(value) || item.full_name?.toLowerCase().includes(value) || item.email?.toLowerCase().includes(value);
  });

  const totalPages = Math.max(1, Math.ceil(filteredFeedback.length / FEEDBACK_PER_PAGE));
  const startIndex = (currentPage - 1) * FEEDBACK_PER_PAGE;
  const paginatedFeedback = filteredFeedback.slice(startIndex, startIndex + FEEDBACK_PER_PAGE);

  return (
    <Layout>
      <div className="table_page">
        <Title subtitle="Manage feedback" title="Feedback" />
        <div className="table_controls_card">
          <label className="table_search">
            <img alt="" src={searchIcon} />
            <input onChange={(e) => setSearch(e.target.value)} placeholder="Search feedback..." value={search} />
          </label>
          <div className="table_controls_actions">
            <span>{filteredFeedback.length} total records</span>
            <button className="table_primary_button" onClick={() => setIsCreateOpen(true)} type="button">
              Add Feedback
            </button>
          </div>
        </div>
        <div className="table_card">
          <div className="table_scroll">
            <table className="data_table">
              <thead><tr><th>ID</th><th>Name</th><th>Email</th><th>Rating</th><th>Message</th><th>Actions</th></tr></thead>
              <tbody>
                {paginatedFeedback.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.full_name}</td>
                    <td>{item.email}</td>
                    <td>{item.rating}</td>
                    <td>{item.message}</td>
                    <td>
                      <div className="table_actions">
                        <button
                          aria-label={`Edit feedback #${item.id}`}
                          className="table_icon_button"
                          onClick={() => editFeedback(item)}
                          type="button"
                        >
                          <img alt="" src={editIcon} />
                        </button>
                        <button
                          aria-label={`Delete feedback #${item.id}`}
                          className="table_icon_button table_icon_button_danger"
                          onClick={() => deleteFeedback(item.id)}
                          type="button"
                        >
                          <img alt="" src={deleteIcon} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="table_pagination">
            <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} type="button">Previous</button>
            <span>Page {currentPage} of {totalPages}</span>
            <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} type="button">Next</button>
          </div>
        </div>
        {isCreateOpen && (
          <div className="table_modal_overlay" onClick={() => setIsCreateOpen(false)}>
            <div className="table_modal" onClick={(e) => e.stopPropagation()}>
              <div className="table_modal_header">
                <div>
                  <h2>Add Feedback</h2>
                </div>
                <button className="table_modal_close" onClick={() => setIsCreateOpen(false)} type="button">
                  x
                </button>
              </div>
              <form className="table_form" onSubmit={createFeedback}>
                <div className="table_form_grid">
                  <label className="table_form_field">
                    <span>Full Name</span>
                    <input onChange={(e) => setFullName(e.target.value)} placeholder="Full name" value={fullName} />
                  </label>
                  <label className="table_form_field">
                    <span>Email</span>
                    <input onChange={(e) => setEmail(e.target.value)} placeholder="Email" value={email} />
                  </label>
                  <label className="table_form_field">
                    <span>Rating</span>
                    <input onChange={(e) => setRating(e.target.value)} placeholder="Rating" value={rating} />
                  </label>
                  <label className="table_form_field table_form_field_full">
                    <span>Message</span>
                    <textarea onChange={(e) => setMessage(e.target.value)} rows={3} value={message} />
                  </label>
                </div>
                <div className="table_form_actions">
                  <button className="table_secondary_button" onClick={() => setIsCreateOpen(false)} type="button">
                    Cancel
                  </button>
                  <button className="table_primary_button">Create</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {isEditOpen && (
          <div className="table_modal_overlay" onClick={() => setIsEditOpen(false)}>
            <div className="table_modal" onClick={(e) => e.stopPropagation()}>
              <div className="table_modal_header">
                <div>
                  <h2>Edit Feedback</h2>
                </div>
                <button className="table_modal_close" onClick={() => setIsEditOpen(false)} type="button">
                  x
                </button>
              </div>
              <form className="table_form" onSubmit={updateFeedback}>
                <div className="table_form_grid">
                  <label className="table_form_field">
                    <span>Full Name</span>
                    <input onChange={(e) => setEditFullName(e.target.value)} value={editFullName} />
                  </label>
                  <label className="table_form_field">
                    <span>Email</span>
                    <input onChange={(e) => setEditEmail(e.target.value)} value={editEmail} />
                  </label>
                  <label className="table_form_field">
                    <span>Rating</span>
                    <input onChange={(e) => setEditRating(e.target.value)} value={editRating} />
                  </label>
                  <label className="table_form_field table_form_field_full">
                    <span>Message</span>
                    <textarea onChange={(e) => setEditMessage(e.target.value)} rows={3} value={editMessage} />
                  </label>
                </div>
                <div className="table_form_actions">
                  <button className="table_secondary_button" onClick={() => setIsEditOpen(false)} type="button">
                    Cancel
                  </button>
                  <button className="table_primary_button">Save</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Feedback;
